import { z } from "zod";

/** Represents the enum public.cli_auth_session_status */
type CliAuthSessionStatus = "pending" | "completed" | "expired";

export default CliAuthSessionStatus;

/** Zod schema for cli_auth_session_status */
export const cliAuthSessionStatus = z.enum(["pending", "completed", "expired"]);
